function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useCallback } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import { useCell, useRow } from '../../hooks/table';
import { useTableTheme } from './hooks/useTableTheme';
import { TableColumnRender } from './TableColumnRender';
export var TableRow = memo(function (props) {
  var onExpand = useCallback(function () {
    return void 0;
  }, []);
  return React.createElement(TableRowRender, Object.assign({}, props, {
    index: 0,
    serials: [0],
    expanded: false,
    isLeaf: true,
    level: 1,
    onExpand: onExpand
  }));
});
export function TableRowRender(props) {
  var row = props.row,
      index = props.index,
      serials = props.serials,
      className = props.className,
      propRowHeight = props.rowHeight,
      expanded = props.expanded,
      level = props.level,
      isLeaf = props.isLeaf,
      onExpand = props.onExpand,
      renderExpand = props.renderExpand,
      extra = _objectWithoutProperties(props, ["row", "index", "serials", "className", "rowHeight", "expanded", "level", "isLeaf", "onExpand", "renderExpand"]);

  var _useTableTheme = useTableTheme(),
      rowHeight = _useTableTheme.rowHeight;

  var cls = classnames(usePrefixCls('table-row', {
    child: level > 1
  }), className);
  var clsExpand = usePrefixCls('table-expand-content');

  var _useRow = useRow(row),
      nonFixed = _useRow.nonFixedColumns,
      fixedLeft = _useRow.fixedLeftColumns,
      fixedRight = _useRow.fixedRightColumns;

  if (renderExpand) {
    return React.createElement(TableColumnRender, Object.assign({}, extra, {
      className: cls,
      height: propRowHeight != null ? propRowHeight : rowHeight,
      nonFixed: React.createElement("div", {
        className: clsExpand
      }, renderExpand(row, {
        level: level,
        index: index,
        serials: serials,
        isLeaf: isLeaf,
        expanded: expanded
      }, onExpand))
    }));
  }

  var renderColumns = function renderColumns(columns) {
    return columns.map(function (column) {
      return React.createElement(Cell, {
        key: column,
        column: column,
        row: row,
        index: index,
        serials: serials,
        height: propRowHeight != null ? propRowHeight : rowHeight,
        expanded: expanded,
        isLeaf: isLeaf,
        level: level,
        onExpand: onExpand
      });
    });
  };

  return React.createElement(TableColumnRender, Object.assign({}, extra, {
    className: cls,
    height: propRowHeight != null ? propRowHeight : rowHeight,
    fixedLeft: renderColumns(fixedLeft),
    fixedRight: renderColumns(fixedRight),
    nonFixed: renderColumns(nonFixed)
  }));
}

function Cell(props) {
  var row = props.row,
      index = props.index,
      serials = props.serials,
      column = props.column,
      height = props.height,
      level = props.level,
      isLeaf = props.isLeaf,
      expanded = props.expanded,
      onExpand = props.onExpand;

  var _useCell = useCell(column),
      renderData = _useCell.renderData,
      className = _useCell.className,
      width = _useCell.width,
      isFirstShownColumn = _useCell.isFirstShownColumn,
      isLastShownColumn = _useCell.isLastShownColumn;

  var cls = classnames(usePrefixCls('table-cell', {
    body: true,
    first: isFirstShownColumn,
    last: isLastShownColumn
  }), className);
  return React.createElement("div", {
    className: cls,
    style: {
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    }
  }, renderData(row, {
    expanded: expanded,
    isLeaf: isLeaf,
    level: level,
    serials: serials,
    index: index
  }, onExpand));
}